(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-mc-open]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      button.addEventListener('click', () => document.getElementById(button.dataset.mcOpen)?.showModal());
    });
    root.querySelectorAll('[data-mc-close]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      button.addEventListener('click', () => button.closest('dialog').close());
    });
    root.querySelectorAll('dialog').forEach(dialog => {
      if (dialog.dataset.ready) return;
      dialog.dataset.ready = 'true';
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    });
    const params = new URLSearchParams(location.search);
    const project = (params.get('project') || '').trim().slice(0,240);
    root.querySelectorAll('[data-mc-project]').forEach(input => { input.value = project; });
    root.querySelectorAll('[data-mc-project-summary]').forEach(summary => {
      summary.hidden = !project;
      summary.querySelector('[data-mc-project-text]').textContent = project;
    });
    if (project) {
      root.querySelectorAll('.mc-enquiry-form textarea[name="contact[body]"]').forEach(input => {
        const template = input.closest('.mc-inquiry')?.dataset.mcProjectMessage;
        if (!input.value.trim() && template) input.value = `${template.replaceAll('{project}',project)}\n\n`;
      });
      root.querySelectorAll('.mc-inquiry [data-mc-whatsapp]').forEach(link => {
        if (link.dataset.projectReady) return;
        link.dataset.projectReady = 'true';
        const url = new URL(link.href);
        const label = link.closest('.mc-inquiry').querySelector('[data-mc-project-summary] strong')?.textContent || 'Project reference:';
        url.searchParams.set('text', `${url.searchParams.get('text') || ''}\n${label} ${project}`.trim());
        link.href = url.toString();
      });
    }
    let landing = location.pathname;
    try {
      const campaign = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].map(key => params.has(key) ? `${key}=${params.get(key).slice(0,160)}` : '').filter(Boolean).join(' | ');
      if (!sessionStorage.getItem('mc_landing')) sessionStorage.setItem('mc_landing', location.pathname);
      if (campaign) sessionStorage.setItem('mc_campaign', campaign);
      landing = sessionStorage.getItem('mc_landing');
      root.querySelectorAll('[data-mc-campaign]').forEach(input => input.value = sessionStorage.getItem('mc_campaign') || '');
    } catch {}
    root.querySelectorAll('[data-mc-landing]').forEach(input => input.value = landing);
    root.querySelectorAll('[data-mc-model]').forEach(input => { if (!input.value) input.value = (params.get('model') || '').slice(0,1000); });
    root.querySelectorAll('[data-mc-purpose]').forEach(input => { if (project && !input.value && !params.has('model') && params.get('purpose') !== 'multiple') input.value = 'Whole store'; if (params.has('model')) input.value = 'Single cabinet'; if (params.get('purpose') === 'multiple') input.value = 'Multiple cabinets'; });
    root.querySelectorAll('[data-mc-form-success]').forEach(status => {
      if (status.dataset.recorded) return;
      status.dataset.recorded = 'true';
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({event:'mc_enquiry_success',page_path:location.pathname});
    });
    root.querySelectorAll('[data-mc-whatsapp]').forEach(link => {
      if (link.dataset.ready) return;
      link.dataset.ready = 'true';
      link.addEventListener('click', () => { window.dataLayer = window.dataLayer || []; window.dataLayer.push({event:'mc_whatsapp_click',page_path:location.pathname}); });
    });
    root.querySelectorAll('[data-mc-model-library]').forEach(library => {
      if (library.dataset.ready) return;
      library.dataset.ready = 'true';
      const cards = [...library.querySelectorAll('[data-model]')];
      const search = library.querySelector('input[type=search]');
      const filter = library.querySelector('[data-mc-format]');
      const update = () => {
        let visible = 0;
        cards.forEach(card => { card.hidden = !(card.dataset.model.toLowerCase().includes(search.value.trim().toLowerCase()) && (!filter.value || card.dataset.format === filter.value)); if (!card.hidden) visible++; });
        library.querySelector('[data-mc-empty]').hidden = visible !== 0;
        library.querySelector('[data-mc-result-count]').textContent = String(visible);
      };
      const shortlist = () => {
        const models = [...library.querySelectorAll('input[type=checkbox]:checked')].map(input => input.value);
        library.querySelector('[data-mc-selected]').textContent = String(models.length);
        const link = library.querySelector('[data-mc-shortlist]');
        const url = new URL(link.dataset.contact, location.origin);
        if (models.length) url.searchParams.set('model',models.join(', '));
        if (models.length > 1) url.searchParams.set('purpose','multiple');
        link.href = url.pathname + url.search;
      };
      search.addEventListener('input',update);filter.addEventListener('change',update);
      library.addEventListener('change',shortlist);
      library.querySelector('[data-mc-clear]').addEventListener('click',() => { library.querySelectorAll('input[type=checkbox]').forEach(input => input.checked = false);shortlist(); });
      update();shortlist();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => init()); else init();
  document.addEventListener('shopify:section:load',event => init(event.target));
})();
